import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import smoothScroller from 'utils/smoothScroller';
import { toggleModal } from 'actions/modalActions';
import { setSessionVariable } from 'utils/utils';
import * as optimizelyUtil from 'utils/optimizely';

import './BookTransferReminderLayout.scss';

const mapStateToProps = () => ({});

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    toggleModalBound: bindActionCreators(toggleModal, dispatch),
  };
}

export class BookTransferReminderLayout extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    toggleModalBound: PropTypes.func.isRequired,
  }

  scrollToTransfers = () => {
    const { toggleModalBound } = this.props;

    toggleModalBound();
    smoothScroller.smoothScroll('.book-radio-list--transfer', 500, { offset: -20 });
    optimizelyUtil.fireEvent('BookTransferReminderAddTransfer', 'clicked');
  }

  continueBookingFlow = (event) => {
    const { toggleModalBound, onSubmit } = this.props;

    optimizelyUtil.fireEvent('BookTransferReminderContinue', 'clicked');
    toggleModalBound();
    onSubmit(event);
  }

  render() {
    setSessionVariable('transferReminderDisplayed', true);
    optimizelyUtil.fireEvent('BookTransferReminder', 'displayed');

    return (
      <form action="POST" onSubmit={this.continueBookingFlow} className="book-transfer-reminder">
        <h2 className="book-transfer-reminder__title">No transfer added</h2>
        <p className="book-transfer-reminder__text">You haven't added a transfer.</p>
        <p className="book-transfer-reminder__text">Make things easier by adding a transfer now.</p>
        <button className="book-transfer-reminder__btn--close book-transfer-reminder__btn" onClick={this.scrollToTransfers}>Add transfer</button>
        <button className="book-transfer-reminder__btn--continue book-transfer-reminder__btn">I will make my own arrangements</button>
      </form>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BookTransferReminderLayout);



/** WEBPACK FOOTER **
 ** ./src/layouts/BookTransferReminderLayout/BookTransferReminderLayout.jsx
 **/